import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons/faHandHoldingHeart';
import type { IconProps } from '../../types';

export function HandHoldingHeartIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Hand Holding Heart',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faHandHoldingHeart}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
